import Box from '@mui/material/Box';
import { LineChart } from '@mui/x-charts/LineChart';
import { COLORS } from '../../constants/color';

const ChecklistLifecycleChart = ({ stats }) => {
  if (!stats) return null;

  const allDates = Array.from(
    new Set([
      ...Object.keys(stats.requested || {}),
      ...Object.keys(stats.visited || {}),
      ...Object.keys(stats.finalReport || {}),
    ])
  ).sort();

  const requestedData = allDates.map(d => stats.requested?.[d] || 0);
  const visitedData = allDates.map(d => stats.visited?.[d] || 0);
  const finalReportData = allDates.map(d => stats.finalReport?.[d] || 0);

  return (
    <Box sx={{ width: '100%', height: 350 }}>
      <LineChart
        xAxis={[
          {
            scaleType: 'point',
            data: allDates,
            label: 'Date',
          },
        ]}
        yAxis={[
          {
            label: 'Projects',
          },
        ]}
        series={[
          {
            data: requestedData,
            label: 'Requested',
            color: COLORS.INFO,
          },
          {
            data: visitedData,
            label: 'Visited',
            color: COLORS.WARNING,
          },
          {
            data: finalReportData,
            label: 'Final Report',
            color: COLORS.SUCCESS,
          },
        ]}
        margin={{ top: 20, right: 20, bottom: 40, left: 50 }}
      />
    </Box>
  );
};

export default ChecklistLifecycleChart;
